/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
 */
export interface DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
     */
    'cardType': DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum = typeof DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum[keyof typeof DisableTransactionUpperLimitForTheUserAccount200ResponseReissueOneOfCardTypeEnum];


